import { type ResolvedIntlConfig } from 'react-intl-next';

import { getUrlFromLocale } from './get-url-for-locale';
import { type Product } from './intl-types';

/**
 * Lazily loads the locale messages for a given locale from "./locales/<product>/<locale>.json"
 * @param locale The locale to load from
 * @returns The locale messages for the given locale
 */
export const fetchLocaleMessages = async (
  product: Product,
  locale: string
): Promise<ResolvedIntlConfig['messages']> => {
  const url = getUrlFromLocale(locale, product);
  const localisedMessages = await fetch(url).then((response) => response.json());

  return localisedMessages;
};
